import styled from "styled-components";
import { palette, typography } from "@src/core/styles";

export const JwtHighlight = styled.pre`
  ${typography.body_medium_regular};
  font-family: "JetBrains Mono", "Fira Code", "Courier New", monospace;
  font-size: 13px;
  margin: 0;
  padding: 14px;
  background-color: ${palette.colors.surface};
  color: ${palette.colors.onsurface};
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
`;

export const JwtPart = styled.span<{ $color: "header" | "payload" | "signature" }>`
  color: ${({ $color }) => {
    switch ($color) {
      case "header":
        return "#B0360C";
      case "payload":
        return "#6A1B9A";
      case "signature":
        return "#1A6FA3";
      default:
        return "inherit";
    }
  }};
  font-weight: 500;
`;

export const ClaimTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  ${typography.body_medium_regular};

  th,
  td {
    padding: 8px 14px;
    text-align: left;
    border-bottom: 1px solid ${palette.colors.outline_variant};
    vertical-align: top;
  }

  th {
    background-color: ${palette.colors.surface_container};
    font-weight: 500;
    color: ${palette.colors.onsurface_variant};
  }

  td code {
    font-family: "JetBrains Mono", "Fira Code", "Courier New", monospace;
    font-size: 13px;
    word-break: break-all;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

export const DangerBox = styled.div`
  ${typography.body_medium_regular};
  padding: 10px 14px;
  border-radius: 8px;
  background-color: #fde6e4;
  color: ${palette.colors.error};
  border: 1px solid ${palette.colors.error};
`;

export const SignatureVerifyBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
`;
